import { render, staticRenderFns } from "./WordGroupsForm.vue?vue&type=template&id=b08c72d2&scoped=true&"
import script from "./WordGroupsForm.vue?vue&type=script&lang=js&"
export * from "./WordGroupsForm.vue?vue&type=script&lang=js&"
import style0 from "./WordGroupsForm.vue?vue&type=style&index=0&id=b08c72d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c72d2",
  null
  
)

export default component.exports